import { t } from 'i18next'

interface TranslationLike {
  languageCode: string
  name?: string
}

/**
 * The name to show for a record that carries one name per language.
 *
 * Every caller of this used to end in `|| record.id`, so a menu type or a dish
 * size that had not been translated into the language being viewed surfaced as
 * a raw UUID in the middle of a form. That reads as corrupt data rather than as
 * something simply left untranslated.
 *
 * The order is: the language asked for, then the restaurant's main language,
 * then any translation that exists at all, and only then the placeholder. A
 * name in some other language still tells the user which record this is; an id
 * tells them nothing.
 */
export const translatedName = (
  translations: TranslationLike[] | undefined,
  languageCode: string | undefined,
  defaultLanguageCode?: string,
  fallback: string = t('SIDEBAR_ACCORDION.MISSING_TRANSLATION')
): string => {
  const named = (code: string | undefined): string =>
    (code &&
      translations?.find(item => item.languageCode === code)?.name?.trim()) ||
    ''

  return (
    named(languageCode) ||
    named(defaultLanguageCode) ||
    translations?.find(item => item.name?.trim())?.name?.trim() ||
    fallback
  )
}
